/**
 * Floor of the parameter tables of a jurisdiction with the GENERIC_VAT
 * scheme: three client types and two article types, without any DGI
 * mention or identifier requirement, and neither credit-note natures nor
 * comment lines. The article codes are the stored LOCBIE and LOCSER, which
 * the article SQL guard and the goods/services posting read.
 */
import { blankColumns } from "./dgi-tables.js";
function profileRow(table, code, label, attributes, position) {
    const values = { label, invoiceMention: null, description: null, applicableCase: null };
    return {
        code,
        ...values,
        attributes,
        source: "PROFILE",
        fillableFields: blankColumns(table, values),
        position,
    };
}
const CLIENT_TYPES = [
    profileRow("CLIENT_TYPE", "CC", "Client comptant", { requiresName: false, requiresIFU: false, acceptsNIF: false }, 0),
    profileRow("CLIENT_TYPE", "PM", "Entreprise ou organisation", { requiresName: true, requiresIFU: false, acceptsNIF: false }, 1),
    profileRow("CLIENT_TYPE", "PP", "Particulier", { requiresName: true, requiresIFU: false, acceptsNIF: false }, 2),
];
const ARTICLE_TYPES = [
    profileRow("ARTICLE_TYPE", "LOCBIE", "Bien", { isService: false, isImported: false }, 0),
    profileRow("ARTICLE_TYPE", "LOCSER", "Service", { isService: true, isImported: false }, 1),
];
/** The parameter-table floor of a GENERIC_VAT jurisdiction. */
export const GENERIC_PARAMETER_TABLES = Object.freeze({
    clientTypes: CLIENT_TYPES,
    articleTypes: ARTICLE_TYPES,
    creditNoteTypes: [],
    commentLineTypes: [],
});
//# sourceMappingURL=generic-tables.js.map